import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbcSpinnerComponent } from '@app/layout/components/abc-spinner/abc-spinner.component';
import { CinematicLoaderComponent } from '@app/layout/components/cinematic-loader/cinematic-loader.component';

import { InstallPromptComponent } from '@app/core/shared/components/install-prompt/install-prompt.component';
import { TvFocusableDirective } from '@app/core/shared/directives/tv-focusable.directive';
import { BackButtonComponent } from './components/back-button/back-button.component';

import { ValentineParticlesComponent } from './components/valentine-particles/valentine-particles.component';
import { HoliParticlesComponent } from './components/holi-particles/holi-particles.component';

@NgModule({
  declarations: [AbcSpinnerComponent, CinematicLoaderComponent, InstallPromptComponent, TvFocusableDirective, BackButtonComponent, ValentineParticlesComponent, HoliParticlesComponent],
  imports: [CommonModule],
  exports: [AbcSpinnerComponent, CinematicLoaderComponent, InstallPromptComponent, TvFocusableDirective, BackButtonComponent, ValentineParticlesComponent, HoliParticlesComponent],
})
export class SharedModule {}
